export default {
  add: 'PLANNING_ACTIONS_ADD',
  loadLastItem: 'PLANNING_ACTIONS_LOAD_LAST_ITEM',
  load: 'PLANNING_ACTIONS_LOAD',
  loadRange: 'PLANNING_ACTIONS_LOAD_RANGE',
  loadPast: 'PLANNING_ACTIONS_LOAD_PAST',
  reload: 'PLANNING_ACTIONS_RELOAD',
  deleteAll: 'PLANNING_ACTIONS_DELETE_ALL',
  deleteCultivation: 'PLANNING_ACTIONS_DELETE_CULTIVATION',
  deleteItem: 'PLANNING_ACTIONS_DELETE_ITEM',
  scheduleNotifications: 'PLANNING_SCHEDULE_NOTIFICATIONS'
}
